"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3871],{

/***/ 23871:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ components_DatesRangePicker; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./components/elements/DateSearch/components/DatesRangePicker/styles.module.scss
var styles_module = __webpack_require__(83378);
var styles_module_default = /*#__PURE__*/__webpack_require__.n(styles_module);
// EXTERNAL MODULE: ./public/icons/icon-calendar.svg
var icon_calendar = __webpack_require__(48976);
// EXTERNAL MODULE: ./components/elements/form/CustomField/index.js + 1 modules
var CustomField = __webpack_require__(56375);
// EXTERNAL MODULE: ./providers/ResponsiveContext.js
var ResponsiveContext = __webpack_require__(40670);
// EXTERNAL MODULE: ./providers/SearchContext.js
var SearchContext = __webpack_require__(65079);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/moment/moment.js
var moment = __webpack_require__(30381);
var moment_default = /*#__PURE__*/__webpack_require__.n(moment);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./node_modules/react-dom/index.js
var react_dom = __webpack_require__(73935);
// EXTERNAL MODULE: ./components/elements/form/Calendar/index.js + 3 modules
var Calendar = __webpack_require__(84052);
;// CONCATENATED MODULE: ./components/elements/DateSearch/components/DatesRangePicker/hooks/useDateSync.js


/**
 * Custom hook to synchronize dates between search context and local component state
 *
 * This hook manages a complex state machine for date synchronization with the following states:
 *
 * STATE MACHINE:
 * 1. INITIAL_SYNC: First sync on component mount
 *    - Syncs search context dates → local state
 *    - Sets hasSyncedInitialDatesRef to true
 *
 * 2. SEARCH_CONTEXT_CHANGED: Search context dates updated externally (navigation, URL, sessionStorage)
 *    - Always syncs search context → local state
 *    - Handles async date loading scenarios
 *
 * 3. USER_SELECTING: Calendar is open, user actively selecting dates
 *    - Blocks sync to prevent interrupting user interaction
 *    - Exceptions: initial sync, search context changes, filter variant on rentals page
 *
 * 4. PROPERTY_FLEXIBILITY: Property variant with flexibility enabled (offsetable !== 0)
 *    - Blocks sync, dates should not be shown when flexibility is active
 *
 * 5. SYNC_TO_LOCAL: Search context has dates that should flow to local state
 *    - Compares dates and syncs if different
 *    - Updates form values immediately
 *
 * 6. CLEAR_LOCAL: Neither search nor local has dates, ensure clean state
 *    - Clears local state if needed
 *
 * EDGE CASES HANDLED:
 * - Navigation with dates in sessionStorage (searchContextChanged detection)
 * - Async date loading after component mount (searchContextChanged detection)
 * - Filter variant auto-expansion with initial dates (shouldAllowSync logic)
 * - Homepage preserves local selections (doesn't overwrite with null from search)
 * - Property variant respects flexibility setting (offsetable check)
 *
 * @param {Object} params - Hook parameters
 * @param {moment|null} params.searchStartDate - Start date from search context
 * @param {moment|null} params.searchEndDate - End date from search context
 * @param {moment|null} params.localStartDate - Local component start date state
 * @param {moment|null} params.localEndDate - Local component end date state
 * @param {Function} params.setLocalStartDate - Setter for local start date
 * @param {Function} params.setLocalEndDate - Setter for local end date
 * @param {Function} params.setFieldValue - Formik field setter
 * @param {boolean} params.isPropertyVariant - Is this the property page variant?
 * @param {number} params.offsetable - Flexibility setting (0 = exact dates, 1-3 = flexible)
 * @param {boolean} params.showCalendar - Is calendar dropdown currently open?
 * @param {boolean} params.isFilterVariant - Is this the filter variant?
 * @param {string} params.routerPathname - Current router pathname
 * @param {React.RefObject} params.hasSyncedInitialDatesRef - Ref tracking if initial sync occurred
 * @param {React.RefObject} params.searchContextDatesRef - Ref tracking previous search context dates
 */ var useDateSync = function(param) {
    var searchStartDate = param.searchStartDate, searchEndDate = param.searchEndDate, localStartDate = param.localStartDate, localEndDate = param.localEndDate, setLocalStartDate = param.setLocalStartDate, setLocalEndDate = param.setLocalEndDate, setFieldValue = param.setFieldValue, isPropertyVariant = param.isPropertyVariant, offsetable = param.offsetable, showCalendar = param.showCalendar, isFilterVariant = param.isFilterVariant, routerPathname = param.routerPathname, hasSyncedInitialDatesRef = param.hasSyncedInitialDatesRef, searchContextDatesRef = param.searchContextDatesRef;
    (0,react.useEffect)(function() {
        // STEP 1: Detect if search context dates changed (navigation, URL updates, sessionStorage)
        var prevStart = searchContextDatesRef.current.startDate;
        var prevEnd = searchContextDatesRef.current.endDate;
        // Safely compare dates - check if they are moment objects before calling valueOf()
        var searchContextChanged = (moment_default().isMoment(prevStart) && moment_default().isMoment(searchStartDate) ? prevStart.valueOf() !== searchStartDate.valueOf() : prevStart !== searchStartDate) || (moment_default().isMoment(prevEnd) && moment_default().isMoment(searchEndDate) ? prevEnd.valueOf() !== searchEndDate.valueOf() : prevEnd !== searchEndDate);
        // Update ref BEFORE checking conditions (ensures next render sees current values)
        searchContextDatesRef.current = {
            startDate: searchStartDate,
            endDate: searchEndDate
        };
        // STEP 2: Determine if we should allow sync during calendar interaction
        // These conditions check different reasons we might need to sync while calendar is open
        var isInitialSync = !hasSyncedInitialDatesRef.current // First render - always sync
        ;
        var isFilterVariantOnRentalsPage = isFilterVariant && routerPathname === "/vacation-rentals" // Filter modal on rentals page
        ;
        var searchHasDates = searchStartDate || searchEndDate // Search context has date data
        ;
        // Allow sync if any of these conditions are true:
        // - Initial sync: First render, component needs to load dates from search context
        // - Search context changed: Navigation/URL updated dates externally, override local state
        // - Filter variant on rentals page with dates: Always sync to show saved dates in modal
        var shouldAllowSync = isInitialSync || searchContextChanged || isFilterVariantOnRentalsPage && searchHasDates;
        // Block sync if calendar is open and none of the exceptions apply
        if (showCalendar && !shouldAllowSync) {
            return;
        }
        // STEP 3: Property variant with flexibility blocks date sync
        if (isPropertyVariant && offsetable !== 0) {
            return;
        }
        // STEP 4: Sync search context → local state
        var localHasDates = localStartDate || localEndDate;
        if (searchHasDates) {
            // Check if dates differ - safely handle moment objects
            var startDateChanged = searchStartDate && !localStartDate || !searchStartDate && localStartDate || moment_default().isMoment(searchStartDate) && moment_default().isMoment(localStartDate) && searchStartDate.valueOf() !== localStartDate.valueOf();
            var endDateChanged = searchEndDate && !localEndDate || !searchEndDate && localEndDate || moment_default().isMoment(searchEndDate) && moment_default().isMoment(localEndDate) && searchEndDate.valueOf() !== localEndDate.valueOf();
            // Sync if dates differ, initial sync, search changed, or search has dates but local doesn't
            var shouldSync = startDateChanged || endDateChanged || isInitialSync && searchHasDates || searchContextChanged || !localHasDates && searchHasDates;
            if (shouldSync) {
                // Sync dates from search context to local state
                setLocalStartDate(searchStartDate);
                setLocalEndDate(searchEndDate);
                // Update form values immediately to keep Formik in sync
                setFieldValue("startDate", searchStartDate);
                setFieldValue("endDate", searchEndDate);
                hasSyncedInitialDatesRef.current = true;
            } else if (isInitialSync) {
                // Mark as synced even if dates match (prevents re-running on next render)
                hasSyncedInitialDatesRef.current = true;
            }
        } else if (!localHasDates && hasSyncedInitialDatesRef.current) {
            // STEP 5: Clear local state if neither has dates (after initial sync)
            if (localStartDate !== null || localEndDate !== null) {
                setLocalStartDate(null);
                setLocalEndDate(null);
            }
        } else if (isInitialSync && !localHasDates) {
            // STEP 6: Initial sync with no dates - mark as synced
            hasSyncedInitialDatesRef.current = true;
        }
    // NOTE: If local has dates but search doesn't, preserve local dates
    // The separate update effect will sync local → search context
    }, [
        searchStartDate,
        searchEndDate,
        localStartDate,
        localEndDate,
        setLocalStartDate,
        setLocalEndDate,
        setFieldValue,
        isPropertyVariant,
        offsetable,
        showCalendar,
        isFilterVariant,
        routerPathname,
        hasSyncedInitialDatesRef,
        searchContextDatesRef
    ]);
};

;// CONCATENATED MODULE: ./components/elements/DateSearch/components/DatesRangePicker/index.js
/* provided dependency */ var process = __webpack_require__(83454);


















// Dynamic import for Calendar to support SSR
var DatesRangePicker_Calendar = dynamic_default()(function() {
    return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 84052));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(84052)
            ];
        }
    },
    ssr: false,
    loading: function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            children: "Loading calendar..."
        });
    },
    onError: function(error) {
        if (typeof process !== "undefined" && // eslint-disable-next-line no-undef
        "production" === "development") {}
        // Return fallback component
        return function() {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                style: {
                    padding: "20px",
                    textAlign: "center",
                    color: "#666"
                },
                children: "Unable to load calendar. Please refresh the page."
            });
        };
    }
});
// Preload Calendar component on hover
var preloadCalendar = function() {
    var ref;
    (ref = DatesRangePicker_Calendar.preload) === null || ref === void 0 ? void 0 : ref.call(DatesRangePicker_Calendar);
    (0,Calendar.preloadReactDates)();
};
// Dropdown portal positioning constants
var DROPDOWN_MIN_WIDTH_PX = 600 // Two-month calendar minimum width
;
var VIEWPORT_EDGE_PADDING_PX = 16 // Breathing room from screen edges
;
// Translations for flexibility buttons and date display
var flexibilityTranslations = {
    exactDates: {
        en: "Exact Dates",
        fr: "Dates exactes",
        es: "Fechas exactas",
        nl: "Exacte data"
    },
    plusMinusOneDay: {
        en: "\xb1 1 day",
        fr: "\xb1 1 jour",
        es: "\xb1 1 d\xeda",
        nl: "\xb1 1 dag"
    },
    plusMinusTwoDays: {
        en: "\xb1 2 days",
        fr: "\xb1 2 jours",
        es: "\xb1 2 d\xedas",
        nl: "\xb1 2 dagen"
    },
    plusMinusThreeDays: {
        en: "\xb1 3 days",
        fr: "\xb1 3 jours",
        es: "\xb1 3 d\xedas",
        nl: "\xb1 3 dagen"
    },
    clearDates: {
        en: "Clear dates",
        fr: "Effacer les dates",
        es: "Borrar fechas",
        nl: "Datums wissen"
    },
    selectDates: {
        en: "Select dates",
        fr: "S\xe9lectionner les dates",
        es: "Seleccionar fechas",
        nl: "Selecteer datums"
    },
    day: {
        en: "day",
        fr: "jour",
        es: "d\xeda",
        nl: "dag"
    },
    days: {
        en: "days",
        fr: "jours",
        es: "d\xedas",
        nl: "dagen"
    }
};
/**
 * DatesRangePicker - Unified date range picker component
 *
 * @param {Object} form - Formik form object with setFieldValue and values
 * @param {Object} shadowRef - Ref for shadow overlay (homepage)
 * @param {Function} setCalendarActive - Callback to set calendar active state (homepage)
 * @param {boolean} custom - Custom positioning variant
 * @param {boolean} icon - Show calendar icon in input (default: false for CustomField, true for property variant)
 * @param {Object} translations - External translations (falls back to internal translations)
 * @param {number} width - Input width (for CustomField variant)
 * @param {string} variant - Visual variant: "homepage", "filter", "property" (default: "homepage")
 * @param {boolean} showFlexibilityButtons - Show flexibility buttons (default: true)
 * @param {Array} blockedDates - Array of moment dates that are blocked (property pages)
 * @param {number} minimumNights - Minimum nights required (default: 1)
 * @param {Object} property - Property object for property variant (contains is_active, terms.minNights)
 * @param {Function} submitForm - Submit form callback (for filter variant on mobile)
 * @param {number} dropdownWidth - Custom dropdown width in pixels (property variant)
 * @param {Array} fieldVariant - Variant array to pass to CustomField (e.g., ['dark', 'dropdown'])
 */ var DatesRangePicker = /*#__PURE__*/ (0,react.memo)(function(param) {
    var _form = param.form, setFieldValue = _form.setFieldValue, values = _form.values, shadowRef = param.shadowRef, setCalendarActive = param.setCalendarActive, custom = param.custom, _icon = param.icon, icon = _icon === void 0 ? false : _icon, translations = param.translations, width = param.width, _variant = param.variant, variant = _variant === void 0 ? "homepage" : _variant, _showFlexibilityButtons = param.showFlexibilityButtons, showFlexibilityButtons = _showFlexibilityButtons === void 0 ? true : _showFlexibilityButtons, _blockedDates = param.blockedDates, blockedDates = _blockedDates === void 0 ? null : _blockedDates, _minimumNights = param.minimumNights, minimumNights = _minimumNights === void 0 ? 1 : _minimumNights, _property = param.property, property = _property === void 0 ? null : _property, submitForm = param.submitForm, dropdownWidth = param.dropdownWidth, fieldVariant = param.fieldVariant;
    var ref;
    var ref1 = (0,SearchContext/* useSearchContext */.AB)(), search = ref1.search, reset = ref1.reset, initialValues = ref1.initialValues, setOffsetable = ref1.setOffsetable, setSearch = ref1.setSearch, offsetable = ref1.offsetable;
    var router = (0,next_router.useRouter)();
    // Determine variant types (must be declared before use)
    var isPropertyVariant = variant === "property";
    var isFilterVariant = variant === "filter";
    // For filter variant on mobile, show calendar expanded by default
    var ref2 = (0,ResponsiveContext/* useResponsive */.F)(), isMobile = ref2.isMobile, isSmallMobile = ref2.isSmallMobile, isLargeDesktop = ref2.isLargeDesktop;
    var shouldAutoExpand = isFilterVariant && !isLargeDesktop;
    var ref3 = (0,react.useState)(shouldAutoExpand), showCalendar = ref3[0], setShowCalendar = ref3[1];
    var wrapperRef = (0,react.useRef)(null);
    // For property variant, only load dates if offsetable is 0 (exact dates)
    // For other variants, always load dates from search context
    // Note: Initial state uses search context, but sync effect will update if dates load asynchronously
    var shouldLoadDates = !isPropertyVariant || offsetable === 0;
    var ref4 = (0,react.useState)(function() {
        return shouldLoadDates ? (search === null || search === void 0 ? void 0 : search.startDate) || null : null;
    }), startDate = ref4[0], setStartDate = ref4[1];
    var ref5 = (0,react.useState)(function() {
        return shouldLoadDates ? (search === null || search === void 0 ? void 0 : search.endDate) || null : null;
    }), endDate = ref5[0], setEndDate = ref5[1];
    var ref6 = (0,react.useState)(false), loaded = ref6[0], setLoaded = ref6[1];
    var ref7 // 0 = exact, 1, 2, or 3 days
     = (0,react.useState)(0), flexibility = ref7[0], setFlexibility = ref7[1];
    var ref8 = (0,react.useState)(null), portalContainer = ref8[0], setPortalContainer = ref8[1];
    var ref9 = (0,react.useState)(null), dropdownPosition = ref9[0], setDropdownPosition = ref9[1];
    var dropdownPortalRef = (0,react.useRef)({
        node: null
    });
    var calendarDropdownRef = (0,react.useRef)(null);
    var hasSyncedInitialDatesRef = (0,react.useRef)(false);
    var searchContextDatesRef = (0,react.useRef)({
        startDate: null,
        endDate: null
    });
    // Use portal for filter variant on large desktop, homepage variant on non-mobile, or property variant on non-mobile
    // This ensures the calendar dropdown can overflow parent containers (like grids) that may clip content
    // On mobile, don't use portal so CSS mobile styles can properly constrain the width
    var shouldUsePortal = isFilterVariant && isLargeDesktop || variant === "homepage" && !isMobile || isPropertyVariant && !isMobile;
    // Get minimum nights from property or prop
    var effectiveMinimumNights = (property === null || property === void 0 ? void 0 : (ref = property.terms) === null || ref === void 0 ? void 0 : ref.minNights) || minimumNights;
    // Get translations - use provided translations or fallback to internal
    var getTranslation = (0,react.useCallback)(function(key) {
        var ref;
        // Try external translations first (for homepage/filter variants)
        if (translations === null || translations === void 0 ? void 0 : translations.dates) {
            if (key === "dates") return translations.dates[router.locale];
            if (key === "clear" && translations.clear) return translations.clear[router.locale];
            if (key === "exactDates" && translations.exactDates) return translations.exactDates[router.locale];
            if (key === "days" && translations.days) return translations.days[router.locale];
        }
        // Fallback to internal translations
        if (key === "dates") return flexibilityTranslations.selectDates[router.locale];
        if (key === "clear") return flexibilityTranslations.clearDates[router.locale];
        if (key === "exactDates") return flexibilityTranslations.exactDates[router.locale];
        if (key === "days") return flexibilityTranslations.days[router.locale];
        return ((ref = flexibilityTranslations[key]) === null || ref === void 0 ? void 0 : ref[router.locale]) || key;
    }, [
        translations,
        router.locale
    ]);
    // Memoize formatted date strings to avoid recalculation
    var formattedDates = (0,react.useMemo)(function() {
        if (!startDate) return getTranslation("dates");
        var startMonth = moment_default()(startDate).format("MMM").toUpperCase();
        var startDay = moment_default()(startDate).format("D");
        if (!endDate) {
            var dateString = "".concat(startMonth, " ").concat(startDay);
            // Add flexibility indicator if enabled and not exact dates
            if (showFlexibilityButtons && flexibility > 0) {
                var dayText = flexibility === 1 ? flexibilityTranslations.day[router.locale] : flexibilityTranslations.days[router.locale];
                dateString += " (\xb1".concat(flexibility, " ").concat(dayText, ")");
            }
            return dateString;
        }
        var endMonth = moment_default()(endDate).format("MMM").toUpperCase();
        var endDay = moment_default()(endDate).format("D");
        // Smart month display - only show month once if same month
        var dateString1;
        if (startMonth === endMonth) {
            dateString1 = "".concat(startMonth, " ").concat(startDay, "-").concat(endDay);
        } else {
            dateString1 = "".concat(startMonth, " ").concat(startDay, " - ").concat(endMonth, " ").concat(endDay);
        }
        // Add flexibility indicator if enabled and not exact dates
        if (showFlexibilityButtons && flexibility > 0) {
            var dayText1 = flexibility === 1 ? flexibilityTranslations.day[router.locale] : flexibilityTranslations.days[router.locale];
            dateString1 += " (\xb1".concat(flexibility, " ").concat(dayText1, ")");
        }
        return dateString1;
    }, [
        startDate,
        endDate,
        flexibility,
        showFlexibilityButtons,
        getTranslation,
        router.locale
    ]);
    // Handle date changes from Calendar
    var handleStartDateChange = (0,react.useCallback)(function(newStartDate) {
        var normalizedStartDate = newStartDate ? moment_default()(newStartDate).utc().startOf("day") : null;
        // Auto-clear checkout if new check-in is after current checkout
        if (normalizedStartDate && endDate && normalizedStartDate.isAfter(endDate)) {
            setStartDate(normalizedStartDate);
            setEndDate(null);
        } else {
            setStartDate(normalizedStartDate);
        }
    }, [
        endDate
    ]);
    var handleEndDateChange = (0,react.useCallback)(function(newEndDate) {
        var normalizedEndDate = newEndDate ? moment_default()(newEndDate).utc().startOf("day") : null;
        setEndDate(normalizedEndDate);
    }, []);
    // Handle click outside
    var handleClickOutside = (0,react.useCallback)(function(event) {
        var ref, ref1;
        // Don't close calendar in mobile modal for filter variant
        if (shouldAutoExpand) {
            return;
        }
        // Check if click is inside wrapper (input field)
        var clickedInsideWrapper = (ref = wrapperRef.current) === null || ref === void 0 ? void 0 : ref.contains(event.target);
        // Check if click is inside calendar dropdown (both portal and non-portal)
        var clickedInsideDropdown = (ref1 = calendarDropdownRef.current) === null || ref1 === void 0 ? void 0 : ref1.contains(event.target);
        // Check if click is inside portal container (when using portal)
        var clickedInsidePortal = portalContainer === null || portalContainer === void 0 ? void 0 : portalContainer.contains(event.target);
        // Check if click is on calendar elements (using data attributes for reliability)
        var clickedOnCalendarElements = event.target.closest("[data-calendar-element]") || event.target.closest('[class*="DayPicker"]') || event.target.closest(".calendar-footer");
        // Only close if click is outside all calendar-related elements
        if (!clickedInsideWrapper && !clickedInsideDropdown && !clickedInsidePortal && !clickedOnCalendarElements) {
            setShowCalendar(false);
        }
    }, [
        shouldAutoExpand,
        portalContainer
    ]);
    // Set up click outside handler
    (0,react.useEffect)(function() {
        document.addEventListener("mousedown", handleClickOutside);
        return function() {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [
        handleClickOutside
    ]);
    // Sync dates between search context and local state
    // Extracted to custom hook for maintainability
    useDateSync({
        searchStartDate: search.startDate,
        searchEndDate: search.endDate,
        localStartDate: startDate,
        localEndDate: endDate,
        setLocalStartDate: setStartDate,
        setLocalEndDate: setEndDate,
        setFieldValue: setFieldValue,
        isPropertyVariant: isPropertyVariant,
        offsetable: offsetable,
        showCalendar: showCalendar,
        isFilterVariant: isFilterVariant,
        routerPathname: router.pathname,
        hasSyncedInitialDatesRef: hasSyncedInitialDatesRef,
        searchContextDatesRef: searchContextDatesRef
    });
    // Update form values and search context when dates change
    (0,react.useEffect)(function() {
        setFieldValue("startDate", startDate);
        setFieldValue("endDate", endDate);
        // Update search context for all variants to ensure dates persist
        // Only update if dates actually changed to avoid unnecessary updates
        if (setSearch) {
            setSearch(function(prevState) {
                var ref, ref1;
                var prevStartValue = (ref = prevState.startDate) === null || ref === void 0 ? void 0 : ref.valueOf();
                var prevEndValue = (ref1 = prevState.endDate) === null || ref1 === void 0 ? void 0 : ref1.valueOf();
                var newStartValue = startDate === null || startDate === void 0 ? void 0 : startDate.valueOf();
                var newEndValue = endDate === null || endDate === void 0 ? void 0 : endDate.valueOf();
                // Only update if dates actually changed
                if (prevStartValue !== newStartValue || prevEndValue !== newEndValue) {
                    return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prevState), {
                        startDate: startDate,
                        endDate: endDate
                    });
                }
                return prevState;
            });
        }
    }, [
        startDate,
        endDate,
        setFieldValue,
        setSearch
    ]);
    // Update offsetable in search context when flexibility changes (only if enabled)
    (0,react.useEffect)(function() {
        if (showFlexibilityButtons) {
            setOffsetable(flexibility);
        } else {
            // Property variant always sets offsetable to 0
            setOffsetable(0);
        }
    }, [
        flexibility,
        setOffsetable,
        showFlexibilityButtons
    ]);
    // Handle shadow overlay (homepage variant)
    (0,react.useEffect)(function() {
        if (shadowRef) {
            if (showCalendar) {
                var ref;
                (ref = shadowRef.current) === null || ref === void 0 ? void 0 : ref.classList.add("isVisible");
            } else {
                var ref1;
                (ref1 = shadowRef.current) === null || ref1 === void 0 ? void 0 : ref1.classList.remove("isVisible");
            }
        }
    }, [
        shadowRef,
        showCalendar
    ]);
    // Handle reset from search context
    (0,react.useEffect)(function() {
        var shouldReset = reset || (search === null || search === void 0 ? void 0 : search.reset);
        if (shouldReset) {
            setStartDate(initialValues === null || initialValues === void 0 ? void 0 : initialValues.startDate);
            setEndDate(initialValues === null || initialValues === void 0 ? void 0 : initialValues.endDate);
            setFlexibility(0);
        }
    }, [
        reset,
        search === null || search === void 0 ? void 0 : search.reset,
        initialValues
    ]);
    // Update parent component's active state (homepage variant)
    (0,react.useEffect)(function() {
        if (setCalendarActive) {
            setCalendarActive(search.startDate && search.endDate || showCalendar);
        }
    }, [
        showCalendar,
        search.startDate,
        search.endDate,
        setCalendarActive,
        values
    ]);
    // Set loaded state after mount
    (0,react.useEffect)(function() {
        return setLoaded(true);
    }, []);
    (0,react.useEffect)(function() {
        if (typeof document === "undefined") return;
        var node = document.createElement("div");
        node.setAttribute("data-dates-portal", "true");
        document.body.appendChild(node);
        setPortalContainer(node);
        dropdownPortalRef.current.node = node;
        return function() {
            // Defensive cleanup: only remove if node is still in DOM
            if (node.parentNode) {
                node.parentNode.removeChild(node);
            }
            dropdownPortalRef.current.node = null;
        };
    }, []);
    var updateDropdownPosition = (0,react.useCallback)(function() {
        if (!shouldUsePortal || !wrapperRef.current || "object" === "undefined") {
            return;
        }
        var rect = wrapperRef.current.getBoundingClientRect();
        var viewportWidth = window.innerWidth || document.documentElement.clientWidth || 0;
        var minWidth = dropdownWidth || DROPDOWN_MIN_WIDTH_PX;
        var width = Math.max(rect.width, minWidth);
        var maxLeft = Math.max(VIEWPORT_EDGE_PADDING_PX, viewportWidth - width - VIEWPORT_EDGE_PADDING_PX);
        var left = Math.min(Math.max(rect.left, VIEWPORT_EDGE_PADDING_PX), Math.max(maxLeft, VIEWPORT_EDGE_PADDING_PX));
        setDropdownPosition({
            top: rect.bottom + 8,
            left: left,
            width: width
        });
    }, [
        shouldUsePortal,
        dropdownWidth
    ]);
    (0,react.useEffect)(function() {
        if (!shouldUsePortal || !showCalendar) {
            return;
        }
        updateDropdownPosition();
        // Throttle scroll handler to prevent excessive re-renders
        // Uses 100ms delay to balance responsiveness with performance
        var scrollThrottleTimer = null;
        var handleReposition = function() {
            updateDropdownPosition();
        };
        var throttledScrollHandler = function() {
            if (scrollThrottleTimer === null) {
                scrollThrottleTimer = setTimeout(function() {
                    handleReposition();
                    scrollThrottleTimer = null;
                }, 100);
            }
        };
        window.addEventListener("resize", handleReposition);
        window.addEventListener("scroll", throttledScrollHandler, true);
        return function() {
            window.removeEventListener("resize", handleReposition);
            window.removeEventListener("scroll", throttledScrollHandler, true);
            // Clear any pending throttle timer on cleanup
            if (scrollThrottleTimer !== null) {
                clearTimeout(scrollThrottleTimer);
            }
        };
    }, [
        shouldUsePortal,
        showCalendar,
        updateDropdownPosition
    ]);
    (0,react.useEffect)(function() {
        if (!shouldUsePortal) {
            setDropdownPosition(null);
        }
    }, [
        shouldUsePortal
    ]);
    // Keep calendar expanded in mobile modal for filter variant
    (0,react.useEffect)(function() {
        if (shouldAutoExpand) {
            setShowCalendar(true);
        }
    }, [
        shouldAutoExpand
    ]);
    // Handle toggle calendar
    var toggleCalendar = (0,react.useCallback)(function() {
        // Don't allow closing in mobile modal for filter variant
        if (shouldAutoExpand) {
            return;
        }
        setShowCalendar(function(prev) {
            return !prev;
        });
    }, [
        shouldAutoExpand
    ]);
    // Handle clear dates
    var handleClearDates = (0,react.useCallback)(function() {
        setStartDate(null);
        setEndDate(null);
        setFlexibility(0);
        setFieldValue("startDate", null);
        setFieldValue("endDate", null);
        setOffsetable(0);
        // Update search context for all variants to ensure dates are cleared
        if (setSearch) {
            setSearch(function(prevState) {
                return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prevState), {
                    startDate: null,
                    endDate: null
                });
            });
        }
        // Auto-submit on mobile for filter variant
        if (isFilterVariant && !isLargeDesktop && submitForm) {
            setTimeout((0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            _ctx.next = 2;
                            return submitForm();
                        case 2:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee);
            })), 50);
        }
    }, [
        setFieldValue,
        setOffsetable,
        isFilterVariant,
        isLargeDesktop,
        submitForm,
        setSearch
    ]);
    // Handle flexibility button click
    var handleFlexibilityClick = (0,react.useCallback)(function(days) {
        setFlexibility(days);
    }, []);
    // Date range display
    var dateRangeString = formattedDates;
    // Determine number of months based on screen size
    var numberOfMonths = isMobile || isSmallMobile ? 1 : 2;
    // Check if property is active (for property variant)
    var isDisabled = isPropertyVariant && property && !property.is_active;
    // Calendar translations object
    var calendarTranslations = translations || {
        dates: flexibilityTranslations.selectDates,
        clear: {
            en: "Clear",
            fr: "Effacer",
            es: "Borrar",
            nl: "Wissen"
        }
    };
    // Render input based on variant
    var renderInput = function() {
        if (isPropertyVariant) {
            // Property variant uses custom button with icon
            var isActive = startDate || endDate || showCalendar;
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                type: "button",
                className: classnames_default()((styles_module_default()).dates__input, isActive && (styles_module_default())["dates__input--active"]),
                onClick: toggleCalendar,
                onMouseEnter: preloadCalendar,
                "aria-label": "Select dates",
                disabled: isDisabled,
                title: isDisabled ? "This property is currently unavailable" : undefined,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(icon_calendar/* default */.Z, {
                        width: 22,
                        height: 22,
                        className: (styles_module_default()).dates__icon
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: (styles_module_default()).dates__value,
                        children: dateRangeString
                    })
                ]
            });
        }
        // Homepage and filter variants use CustomField
        // Compute variant: use fieldVariant if provided, otherwise default based on mobile state
        var computedVariant = fieldVariant || [
            isMobile && "full-width"
        ];
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomField/* default */.Z, {
            "aria-label": "Select dates",
            type: "text",
            readOnly: true,
            angle: true,
            width: width || (isFilterVariant && !isMobile ? 13 : undefined),
            variant: computedVariant,
            prependIcon: icon ? /*#__PURE__*/ (0,jsx_runtime.jsx)(icon_calendar/* default */.Z, {
                width: 26,
                height: 26
            }) : undefined,
            onClick: toggleCalendar,
            onMouseEnter: preloadCalendar,
            isActive: startDate && endDate || showCalendar,
            value: dateRangeString,
            disabled: isDisabled,
            title: isDisabled ? "This property is currently unavailable" : undefined
        });
    };
    // Render flexibility buttons
    var renderFlexibilityButtons = function() {
        if (!showFlexibilityButtons) return null;
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (styles_module_default()).dates__flexibility,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                    type: "button",
                    "aria-pressed": flexibility === 0,
                    className: classnames_default()((styles_module_default()).dates__flexButton, flexibility === 0 && (styles_module_default())["dates__flexButton--active"]),
                    onClick: function() {
                        return handleFlexibilityClick(0);
                    },
                    children: getTranslation("exactDates")
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                    type: "button",
                    "aria-pressed": flexibility === 1,
                    className: classnames_default()((styles_module_default()).dates__flexButton, flexibility === 1 && (styles_module_default())["dates__flexButton--active"]),
                    onClick: function() {
                        return handleFlexibilityClick(1);
                    },
                    children: flexibilityTranslations.plusMinusOneDay[router.locale]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                    type: "button",
                    "aria-pressed": flexibility === 2,
                    className: classnames_default()((styles_module_default()).dates__flexButton, flexibility === 2 && (styles_module_default())["dates__flexButton--active"]),
                    onClick: function() {
                        return handleFlexibilityClick(2);
                    },
                    children: flexibilityTranslations.plusMinusTwoDays[router.locale]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                    type: "button",
                    "aria-pressed": flexibility === 3,
                    className: classnames_default()((styles_module_default()).dates__flexButton, flexibility === 3 && (styles_module_default())["dates__flexButton--active"]),
                    onClick: function() {
                        return handleFlexibilityClick(3);
                    },
                    children: flexibilityTranslations.plusMinusThreeDays[router.locale]
                })
            ]
        });
    };
    // Render clear button
    var renderClearButton = function() {
        var clearText = isFilterVariant && (translations === null || translations === void 0 ? void 0 : translations.clear) ? "".concat(translations.clear[router.locale], " ").concat(translations.dates[router.locale].toLowerCase()) : getTranslation("clear");
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
            type: "button",
            className: (styles_module_default()).dates__clearButton,
            onClick: handleClearDates,
            children: clearText
        });
    };
    var dropdownClassName = classnames_default()((styles_module_default()).dates__wrapper, showCalendar && (styles_module_default()).isActive, custom && (styles_module_default()).custom, isPropertyVariant && (styles_module_default())["dates__wrapper--property"], isFilterVariant && (styles_module_default())["dates__wrapper--filter"]);
    var dropdownStyle = (0,react.useMemo)(function() {
        var baseStyle = dropdownWidth ? {
            "--dropdown-width": "".concat(dropdownWidth, "px")
        } : undefined;
        if (shouldUsePortal && dropdownPosition) {
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, baseStyle), {
                position: "fixed",
                top: "".concat(dropdownPosition.top, "px"),
                left: "".concat(dropdownPosition.left, "px"),
                width: "".concat(dropdownPosition.width, "px"),
                zIndex: 10000
            });
        }
        return baseStyle;
    }, [
        dropdownWidth,
        shouldUsePortal,
        dropdownPosition
    ]);
    var calendarContent = /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        ref: calendarDropdownRef,
        className: dropdownClassName,
        style: dropdownStyle,
        "data-calendar-element": "true",
        "data-calendar-debug": shouldUsePortal ? JSON.stringify({
            rendered: loaded && showCalendar,
            width: (dropdownPosition === null || dropdownPosition === void 0 ? void 0 : dropdownPosition.width) || null,
            height: dropdownPosition ? (dropdownPosition === null || dropdownPosition === void 0 ? void 0 : dropdownPosition.height) || null : null
        }) : undefined,
        children: loaded && showCalendar && /*#__PURE__*/ (0,jsx_runtime.jsx)(DatesRangePicker_Calendar, {
            variant: [
                "large"
            ],
            startDate: startDate,
            endDate: endDate,
            setStartDate: handleStartDateChange,
            setEndDate: handleEndDateChange,
            blockedDates: blockedDates,
            minimumNights: effectiveMinimumNights,
            translations: calendarTranslations,
            numberOfMonths: numberOfMonths,
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: classnames_default()((styles_module_default()).dates__footer, !showFlexibilityButtons && (styles_module_default())["dates__footer--no-flex"]),
                children: [
                    renderFlexibilityButtons(),
                    renderClearButton()
                ]
            })
        })
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        ref: wrapperRef,
        className: classnames_default()((styles_module_default()).dates, isMobile && (styles_module_default())["dates--mobile"], isPropertyVariant && (styles_module_default())["dates--property"], isFilterVariant && (styles_module_default())["dates--filter"]),
        onMouseEnter: preloadCalendar,
        children: [
            renderInput(),
            shouldUsePortal && portalContainer ? /*#__PURE__*/ (0,react_dom.createPortal)(calendarContent, portalContainer) : calendarContent
        ]
    });
});
// Display name for debugging
DatesRangePicker.displayName = "DatesRangePicker";
/* harmony default export */ var components_DatesRangePicker = (DatesRangePicker);


/***/ })

}]);